import React, { useState } from "react";
import "./Dashboard.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Entrepreneurship",
    description:
      "Generate entrepreneurship business plan customized to the criteria of your choice",
    link: "/entrepreneurship-tool",
  },
  {
    title: "HR Tool",
    description:
      "Learn about HR Topics",
    link: "/hr-tool",
  },
  {
    title: "Marketing",
    description:
      "Learn about Marketing Topics including Digital Marketing",
    link: "/marketing-tool",
  },
  {
    title: "Accounting / Finance",
    description:
      "Learn about Accounting and Finance",
    link: "/accounting-finance-tool",
  },
  {
    title: "Business Funding",
    description:
      "Learn about Business Funding",
    link: "/business-funding-tool",
  },
  {
    title: "Organizational Behaviour",
    description:
      "Learn about Organizational Behaviour",
    link: "/organizational-behaviour-tool",
  },
  {
    title: "Ethics",
    description:
      "Learn about Ethics",
    link: "/ethics-tool",
  },
  {
    title: "E-commerce Platforms",
    description:
      "Learn about E-commerce platform",
    link: "/ecommerce-tool",
  },
  {
    title: "Freelance",
    description:
      "Learn about Freelance",
    link: "/freelance-tool",
  },
];

const Card = ({ title, description, link }) => {
  return (
    <div className="space-y-4 w-full bg-white p-4 flex flex-col items-center border border-lightpink">
      <h1 className="text-center text-xl font-bold py-1">{title}</h1>
      <p className="text-gray-500 text-center line-clamp-3">{description}</p>
      <Link
        to={link}
        className="text-sm px-6 py-2 border bg-indigo-600 text-white rounded transition duration-300"
      >
        Open
      </Link>
    </div>
  );
};

const Dashboard = () => {
  return (
    <div className="container mx-auto py-12 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 lg:gap-4">
        {services.map((service, index) => (
          <div key={index} className="px-2 py-4 lg:p-4">
            <Card {...service} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
